<template>
  <div
    class="managePage"
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.4)"
  >
  </div>
</template>
<script>
export default {
  name: "todo",
  data() {
    return {
    };
  },
  created() {
    this.getMenuAuthOne();
  },
  methods: {},
};
</script>
<style lang="less" scoped>
</style>